import React from 'react';
import { Typography, Image, Row, Col, Divider } from 'antd';
import { styles } from '../../../styles';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import RelatedBlog from './RelatedBlogs';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog7() {
  const matches = useMediaQuery('(min-width: 768px)');

  return (
    <>
    <Row style={styles.navLinks}>        
        <p><Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ The Saddest Moments in Football<span></span></p>
    </Row>
    <Row justify='center'>
      <Col xs={24} sm={22} md={20} lg={16}>
        <div style={styles.blogContainer}>
          <Typography>
            <Title level={1} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            The Saddest Moments in <Link to="/">Football</Link>
            </Title>
            <Divider></Divider>
            <Title level={3} style={{...styles.mainHeading, fontSize: !matches ? '20px': '', color:'rgb(215 118 118)'}}>
                1. <a href='https://www.transfermarkt.com/paulo-dybala/profil/spieler/206050' rel='noreferrer' target='_blank'>Dybala</a> last match for <Link to={'/fixtures/team/Juventus'}>Juventus</Link>
            </Title>
            <Paragraph style={styles.blogParagraph}>
            The Saddest Moments in Football History often remind us how deeply players and fans connect. Paulo <a href='https://www.transfermarkt.com/paulo-dybala/profil/spieler/206050' rel='noreferrer' target='_blank'>Dybala</a>, a key figure at Juventus since joining from Palermo in 2015 for £23.8 million, announced an emotional farewell after seven incredible years. 
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            Scoring 115 goals in 291 matches and winning 12 trophies, including five Serie A titles, <a href='https://www.transfermarkt.com/paulo-dybala/profil/spieler/206050' rel='noreferrer' target='_blank'>Dybala</a> made an unforgettable mark.
            </Paragraph>

            <Image
              preview={false}
              src='https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/sddefault.jpg'
              alt='Saddest football moments'
              style={{ borderRadius: '8px', width: matches ? '75%' : '95%', margin: '10px' }}
            />

            <Paragraph style={styles.blogParagraph}>
            In public messages around his departure, Dybala described the farewell as difficult and said he wanted to leave the pitch knowing he had given everything in the shirt. Those remarks were widely reported at the time; this article paraphrases them rather than reproducing the posts.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            He also said the years in Turin had given him emotions he did not expect to end so soon. Whether or not fans agreed with the club’s decision, the goodbye landed as one of those nights where a stadium is louder because it is ending something.            
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            As <a href='https://www.transfermarkt.com/paulo-dybala/profil/spieler/206050' rel='noreferrer' target='_blank'>Dybala</a> bids farewell, his passion and impact on Juventus remain unforgettable, marking this as one of The Saddest Moments in Football History for fans.            </Paragraph>


            <Title level={3} style={{...styles.mainHeading, fontSize: !matches ? '20px': '', color:'rgb(215 118 118)'}}>
                2. John Terry UCL Final penalty miss vs <a href='https://koostream.live/fixtures/team/Manchester%20United'>Manchester United</a>
            </Title>
            <Paragraph style={styles.blogParagraph}>
            The 2008 <a href='https://koostream.live/fixtures/league/UEFA%20Champions%20League'>Champions League</a> final in Moscow was unforgettable, filled with tension and drama. It ended in a sudden-death penalty shootout, with Chelsea just one kick away from victory.
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            John Terry had the chance to win it for Chelsea, but he slipped and hit the post, leaving united fans relieved and Chelsea heartbroken. Most Heartbreaking Moments in United History. Later, Edwin van der Sar saved Nicolas Anelka’s penalty, securing <a href='https://koostream.live/fixtures/team/Manchester%20United'>Manchester United</a>’s triumph.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Sir Alex Ferguson celebrated his second <a href='https://koostream.live/fixtures/league/UEFA%20Champions%20League'>Champions League</a> title, and the club won their third in history, making it a night to remember for united fans.
            </Paragraph>

            <Title level={3} style={{...styles.mainHeading, fontSize: !matches ? '20px': '', color:'rgb(215 118 118)'}}>
                3. Son after breaking an opponent’s leg.
            </Title>

            <Paragraph style={styles.blogParagraph}>
            Tottenham’s Son Heung-min was left in tears after an incident that led to a horrific injury for Everton’s Andre Gomes.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            The injury occurred after Son’s tackle, which made minimal contact, caused Gomes to land awkwardly. Referee <a href='https://www.transfermarkt.com/martin-atkinson/profil/schiedsrichter/381' rel='noreferrer' target='_blank'>Martin Atkinson</a>  initially gave a yellow card but upgraded it to red following a VAR review.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            A Premier League statement explained the card was for “endangering the safety of a player.”
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Dele Alli said Son was devastated, calling the injury “not his fault.” Michael Owen and Gary Lineker also criticized the decision, with Lineker slamming VAR for its role.
            </Paragraph>

            <Title level={3} style={{...styles.mainHeading, fontSize: !matches ? '20px': '', color:'rgb(215 118 118)'}}>
                4. <a href='https://sempremilan.com/ibrahimovic-milan-approval-rating-already-hanging-thread' rel='noreferrer'target='_blank'>Zlatan Ibrahimovic</a> Announces Retirement from Professional Football
            </Title>

            <Paragraph style={styles.blogParagraph}>
            <a href='https://sempremilan.com/ibrahimovic-milan-approval-rating-already-hanging-thread' rel='noreferrer'target='_blank'>Zlatan Ibrahimovic</a> announced his retirement at 41 after AC Milan’s final match against Hellas Verona. The legendary striker, visibly emotional, thanked the San Siro fans, saying that The first time at Milan you gave me happiness, the second time you gave me love. It’s time to say goodbye to football, not to you.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            The Saddest Moments in Football History often mark the end of an era, and Zlatan Ibrahimovic’s retirement is no exception. After an extraordinary 24-year career, Ibrahimovic has called time on his journey, having played for top clubs like Ajax, Juventus, Barcelona, PSG, <a href='https://koostream.live/fixtures/team/Manchester%20United'>Manchester United</a>, and AC Milan. He won league titles in four different countries, cementing his place among football’s greatest.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Despite being limited to just four appearances this season due to injuries, his impact on the sport remains unparalleled. For Sweden, Ibrahimovic scored 62 goals in 121 games, retiring internationally in 2016 before a brief return in 2021.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            When asked about his future, Zlatan ruled out coaching, humorously adding as During a match, I’d slap at least two players!.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            As <a href='https://sempremilan.com/ibrahimovic-milan-approval-rating-already-hanging-thread' rel='noreferrer'target='_blank'> Ibrahimovic</a> steps away from the game, fans are left reflecting on his unmatched charisma, skill, and legendary career, marking this as one of The Saddest Moments in Football History.
            </Paragraph>

            <Title level={3} style={{...styles.mainHeading, fontSize: !matches ? '20px': '', color:'rgb(215 118 118)'}}>
                5. <a href='https://www.transfermarkt.com/christian-eriksen/profil/spieler/69633' rel='noreferrer' target='_blank'> Christian Eriksen</a> collapsing in the field
            </Title>

            <Paragraph style={styles.blogParagraph}>
            The Saddest Moments in Football unfolded on June 12, 2021, during Denmark’s UEFA EURO 2020 match against Finland. <a href='https://www.transfermarkt.com/christian-eriksen/profil/spieler/69633' rel='noreferrer' target='_blank'> Christian Eriksen</a> collapsed on the field, leaving teammates and fans in shock. Denmark’s team doctor, Morten Boesen, quickly realized Eriksen’s life was slipping away and began CPR. For 10 terrifying minutes, medics fought to revive him as teammates formed a protective circle, shielding the scene from the crowd.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Parken Stadium fell silent until cheers erupted when Eriksen was stabilized and carried off the field. His collapse led to the game being suspended for 90 minutes, but players chose to resume the match later. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Finland won 1-0, though the result seemed insignificant compared to Eriksen’s recovery. His survival and stable condition brought immense relief, but the haunting memory remains one of The Saddest Moments in Football history.
            </Paragraph>

            <Divider />
            <Title level={4} style={{...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
              Read More Below
            </Title>
            <Divider />
            <div style={{ paddingRight: '10px' }}>
              <RelatedBlog excludedId={7} />
            </div>

            <BlogFooter />
          </Typography>
        </div>
      </Col>
    </Row>
    </>
  );
}
